import { Injectable, OnInit } from '@angular/core';
import { User } from '../models/user.model';
import jwtDecode from 'jwt-decode';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { GirisService } from './giris.service';
import { Token } from '../models/token.model';

@Injectable({
  providedIn: 'root',
})
export class GenelService {
  user: User = new User();
  tokenaliniyor : boolean;

  constructor(private router: Router,private girisService : GirisService) {}

  getUser(): User {
    const token = localStorage.getItem('token');
    if (token) {
      this.user = jwtDecode(token);
    }
    return this.user;
  }

  YetkiVar(rol : String): boolean {
    let yetki = false;
    
     yetki = this.GirisKontrol();

     if (!yetki) {return false}
    //setTimeout(() => {
     this.getUser;
    //    console.log(this.user );
   if (this.user.Rol.find((p) => p == rol)) {
      yetki = true;
    } else {
      yetki = false;
    }
   // console.log('yetki durum : ' + yetki);
    //}, 1);
    return yetki;
    //    console.log("rol name : " + rol );
  }

  GirisKontrol() : boolean {
    const storage = localStorage.getItem('token') || "";
    if (storage) {
       const token = JSON.parse(storage) as Token;
       /*
       if(this.jwtHelperService.isTokenExpired(token.token)){
         this.girisService.refreshToken(token.userUid).subscribe(res => {
           localStorage.setItem('token', JSON.stringify(res.data));
         });
       }*/
      //  console.log("can activate giriş 1");
        var expirationDate = new Date(token.expiration).getTime();
        var simdikizaman   = new Date(Date.now()).getTime();
        var kontrolzamani = (expirationDate - simdikizaman) / (1000 * 60); // dakika

        if ( simdikizaman >= expirationDate) {
          // console.log("can activate giriş 3");
           localStorage.setItem('token', "");
           this.router.navigate(['/giris']);
           return false;
        };
        

        if (kontrolzamani > 5) {this.tokenaliniyor = false;}

        if (kontrolzamani <= 5 && !this.tokenaliniyor)
        {
          // console.log("can activate giriş 4");
          this.tokenaliniyor = true;
          // this.router.navigate(['/giris']);
          this.girisService.refreshToken(token.userUid) .subscribe(res => {
           localStorage.setItem('token', JSON.stringify(res.data));
          });
        }
       return true;
     }
     this.router.navigate(['/giris']);
     return false;

  }

  success(mesaj : string,beklemezamani : number) {
    alert(mesaj); 
  }
  
  error(mesaj : string,beklemezamani : number) {
    alert(mesaj); 
  }

  /*
  canActivate(next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    return this.hasPermission(next);
  }

  hasPermission(component): Observable<boolean> {
    return this.authService.isLoggedIn().map(res => {
// Get permissions from user object.
        this.permissions = this.getPermissions();
// Check if user object has permissions to access the current component.
        return this.YetkiVar(component.data.permission);
    });
}  */
}
